module.exports = __webpack_public_path__ + "img/s2-1.73f1e5ba.jpg";